<template>
  <div class="content">
    <div v-show="!loaded">
      <div class="lds-dual-ring"></div>
    </div>
    <div class="inner" v-show="loaded">
      <h1 class="title">
        <strong>Profile</strong>
      </h1>

      <div class="actions">
        <a @click.prevent="saveProfile" class="btn edit-save" href>
          <i class="fa fa-check-square-o"></i> Save
        </a>
      </div>

      <schema-section
        :key="section._id"
        :page="page"
        :ref="'section' + index"
        :section="section"
        :single="schema.length == 1 ? true : false"
        @editing="editSection(section, $event)"
        @save="saveSection(section, $event)"
        v-for="(section, index) in schema"
      />
    </div>
  </div>
</template>

<script>
import api from "@/services/api"
import cognito from "@/services/cognito"

import SchemaSection from "@/components/SchemaSection.vue"

export default {
  name: "Profile",
  components: { SchemaSection },
  data: function() {
    return {
      loaded: false,

      schema: [],
      page: { password: "", current_password: "" }
    }
  },
  created() {
    api.getSchema("profile").then(response => {
      this.schema = JSON.parse(JSON.stringify(response)).item
      this.$nextTick().then(() => (this.loaded = true))
    })
  },
  methods: {
    saveProfile() {
      if (this.page.password)
        cognito
          .changePassword(this.page.current_password, this.page.password)
          .then(() => {
            this.$store.dispatch({
              type: "setSuccess",
              message: "Save successful"
            })
          })
          .catch(err => {
            var message = err.code

            if (err.message.includes("proposedPassword") || err.code == "InvalidPasswordException")
              message = "Your new password must be at least 8 characters long, include upper and lower case letters, and a number"

            if (err.message.includes("previousPassword")) message = "Please check your current password"

            this.$store.dispatch({
              type: "setError",
              message: message
            })
          })
    }
  }
}
</script>
